module.exports = __webpack_public_path__ + "img/100.a488ba8b.png";